import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Box } from "@mui/material";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// css
import './ForgotPassword.css';
import logo from '../../../Assets/images/logo.png';
import bannerlogo from "../../../Assets/images/banner-logo.png"
// custom imports
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import { hideLoader, showLoader } from "../../../Redux/Slice/Loader/loaderSlice";
import authService from "../../../Services/Login/LoginService";
import showToast from "../../../Utils/Toast/ToastNotification";


const RootStyle = styled("div")({
  background: "rgb(249, 250, 251)",
  height: "100vh",
  display: "grid",
  placeItems: "center",
});

const HeadingStyle = styled(Box)({
  textAlign: "center",
});

const ContentStyle = styled("div")({
  maxWidth: 480,
  padding: 25,
  margin: "auto",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  background: "#fff",
});

// Easing for animation
let easing = [0.6, -0.05, 0.01, 0.99];
const animate = {
  opacity: 1,
  y: 0,
  transition: {
    duration: 0.6,
    ease: easing,
    delay: 0.16,
  },
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email is required")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/i,
        "Please enter valid email address"
      )
      .matches(/^$|^\S+.*/, "Only blank spaces are not valid."),
  });

  const initialValues = {
    email: ''
  };

  const onSubmit = async (values, { resetForm }) => {
    dispatch(showLoader())
    try {
      const response = await authService.forgotPassword(values);
      if (response?.data?.statusCode === 200) {
        showToast("success", response?.data?.body?.message);
        resetForm();
        navigate("/");
      } else {
        showToast("error", response?.data?.message || "Something went wrong");
      }
    } catch (error) {
      await HandleApiError(error)
    } finally {
      dispatch(hideLoader())
    }
  };

  return (
    <>
      <section className="login-main forget-pw-main">
        <div className="login-block d-flex">
          <div className="logo-mobile">
            <img src={logo}></img>
          </div>
          <div className="banner-img-block">
            <div className="banner-logo-block">
              <img src={bannerlogo} alt="banner-logo"></img>
            </div>
          </div>
          <div className="login-info-block d-flex flex-column align-items-center">
            <div className="logo">
              <img src={logo}></img>
            </div>
            <div className="signup-box">
              <div className="inner-box">
                <div className="d-flex">
                  <h1 className="login_header">Forgot Password</h1>
                </div>
                <Formik
                  initialValues={initialValues}
                  validationSchema={ForgotPasswordSchema}
                  onSubmit={onSubmit}
                >
                  {({ values, handleChange, handleSubmit, errors, touched }) => (
                    <Form className="login-form">
                      <div class="mb-3 email-blk">
                        <label for="email" class="form-label">Email</label>
                        <input
                          type="email"
                          class="form-control"
                          id="email"
                          placeholder="Email"
                          value={values.email}
                          onChange={handleChange}
                        />
                        {touched.email && errors.email && (
                          <div className="error-text">{errors.email}</div>
                        )}
                      </div>
                      <button type="submit" class="green-btn green-signin w-100" onSubmit={handleSubmit}>Send</button>
                    </Form>
                  )
                  }
                </Formik>
                <div className="go-back text-center">Back to Sign In? <a href="/">Go Back</a></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ForgotPassword;
